import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {WorkSansLight} from "@irati/ui/src/global/fonts"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {minWidthMedia} from "@irati/ui/src/global/media"

export const StyledBalanceCard = styled.div`
  margin-bottom: ${padding.small};
  display: flex;
  justify-content: flex-start;
  align-content: center;
  ${WorkSansLight};
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;

  > svg {
    margin: 0 10px;
  }
`

export const StyledButtonRouterLink = styled(ButtonRouterLink)`
  margin-top: 20px;
  ${minWidthMedia.tablet`
    margin-top: 30px;
  `}
`
